import React, { useEffect, useState } from "react";
import { OrderCard } from "./OrderCard";

const validStatuses = ["En ruta"];

export const TableCourier = ({ db, data }) => {
  const [dataNew, setDataNew] = useState([]);


  useEffect(() => {
    const filteredData = data.filter(order => validStatuses.includes(order.status) && order.department === "LIMA");
    setDataNew(filteredData);
  }, [data]);

  return (
    <div className="flex flex-wrap gap-4 w-full">
      {dataNew.length > 0? dataNew.map((record) => (
        <OrderCard db={db} key={record.key} record={record} />
      )) : <p className="w-full flex justify-center">No hay ordenes en ruta</p> }
    </div>
  );
};
